import EFLight from '@elem/ui-assets/icons/appliances/EFLight';
import EFPhone from '@elem/ui-assets/icons/appliances/EFPhone';
import EFCamera from '@elem/ui-assets/icons/appliances/EFCamera';
import EFFan from '@elem/ui-assets/icons/appliances/EFFan';
import EFProjector from '@elem/ui-assets/icons/appliances/EFProjector';
import EFMiniFridge from '@elem/ui-assets/icons/appliances/EFMiniFridge';
import EFDrone from '@elem/ui-assets/icons/appliances/EFDrone';

import EFWiFiRouter from '@elem/ui-assets/icons/appliances/EFWiFi';
import EFLaptop from '@elem/ui-assets/icons/appliances/EFLaptop';
import EFDisplay from '@elem/ui-assets/icons/appliances/EFDisplay';
import EFWaterPump from '@elem/ui-assets/icons/appliances/EFWaterPump';
import EFCarFridge from '@elem/ui-assets/icons/appliances/EFCarFridge';

export default function GetAppIcon({ appliance }: { appliance: string }) {
    const iconMap: { [key: string]: JSX.Element } = {
        Light: <EFLight />,
        Phone: <EFPhone />,
        Camera: <EFCamera />,
        Fan: <EFFan />,
        Projector: <EFProjector />,
        MiniFridge: <EFMiniFridge />,
        Drone: <EFDrone />,
        WiFiRouter: <EFWiFiRouter />,
        Laptop: <EFLaptop />,
        Display: <EFDisplay />,
        WaterPump: <EFWaterPump />,
        CarFridge: <EFCarFridge />,
    };
    return iconMap[appliance] || <></>;
}
